"use strict" ;

/**
 * The policy enumeration of the icons.
 * @summary The policy enumeration of the icons.
 * @name IconPolicy
 * @namespace molecule.IconPolicy
 * @memberof molecule
 * @version 1.0.19
 * @since 1.0.8
 */
const IconPolicy = Object.defineProperties( {} ,
{
    /**
     * The icon area take the size of this container to defines automatically this size.
     * @name AUTO
     * @memberof molecule.IconPolicy
     * @static
     * @type {string}
     * @default 'auto'
     */
    AUTO : { enumerable : true , value : 'auto' } ,

    /**
     * The normal policy, the icon take this current normal size.
     * @name NORMAL
     * @memberof molecule.IconPolicy
     * @static
     * @type {string}
     * @default 'normal'
     */
    NORMAL : { enumerable : true , value : 'normal' }
}) ;

export default IconPolicy;